module.exports = __webpack_public_path__ + "img/no-stock.fb7f689f.png";